import { render, staticRenderFns } from "./chart-bar-protocol.vue?vue&type=template&id=5d1b4253"
import script from "./chart-bar-protocol.vue?vue&type=script&lang=js"
export * from "./chart-bar-protocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports